/**
 * Given every visible item's index and the indexes that actually resolved to
 * a valid, active, correct-exchange account (getSubmissionRows' output),
 * returns the indexes that did NOT — i.e. would otherwise be silently
 * dropped from the submitted batch. A caller must treat any non-empty result
 * as "block the entire submission," not "submit what did resolve": for a
 * multi-account split row (one leg long, one short), submitting only the
 * legs that happened to resolve is an accidental partial hedge, not a benign
 * partial failure. See use-unified-order-form.ts's getSubmissionRows for
 * where visibleIndexes/resolvedIndexes come from.
 */
export function findUnresolvedSubmissionIndexes(
  visibleIndexes: number[],
  resolvedIndexes: number[]
): number[] {
  const resolved = new Set(resolvedIndexes)
  return visibleIndexes.filter((index) => !resolved.has(index))
}
